import React from 'react'
import PatientVisitComponent from '../Components/PatientVisit/PatientVisitComponent'

function PatientVisitPage() {
    return (
        <PatientVisitComponent/>
    )
}

export default PatientVisitPage